<template>
    <Card_Tab :class_color="returnClassEtapa">
        <template v-slot:context>
            <div class="row d-flex align-items-center">  
                <div class="col-5">
                    <h5 class="card-title cart-ticket-top" v-if="dados.idInstituicao > 0">#{{ dados.cdInstituicao }} | {{ dados.nmRazaoSocial }} | {{ dados.nmUf }} | {{ dados.nmAmbito }}</h5>
                    <h5 class="card-title cart-ticket-top" v-else-if="dados.idPessoa > 0">#{{ dados.cdPessoa }} | {{ dados.nmPessoa }} | {{ dados.nmUf }}</h5>
                </div>
                <div class="col-3">
                    <span class="card-title cart-ticket-top">ETAPA ATUAL: <span :class="returnTextEtapa">{{ dados.etapa_atual }}</span></span>
                </div>
                <div class="col-4">
                    <div class="d-flex flex-row-reverse">
                        <div class="">
                            <button type="button" class="btn btn-danger ms-2 btn-style-white" :style="dinamicWid"
                                @click="setActionCard('historico')" data-bs-placement="top" title="Histórico">
                                <i class="fas fa-history r-5"></i> Histórico
                            </button>
                        </div>
                        <div class="r-5" v-if="isFinalizado == false">
                            <button type="button" class="btn btn-danger ms-2 btn-style-white" :style="dinamicWid"
                                @click="setActionCard('finalizar')" data-bs-placement="top" title="Histórico">
                                <i class="fas fa-stamp pe-2"></i> Finalizar
                            </button>
                        </div>
                        <div class="r-5" v-if="isFinalizado == false">
                            <button type="button" class="btn btn-danger ms-2 btn-style-white" :style="dinamicWid"
                                @click="setActionCard('reclassificar')" data-bs-placement="top" title="Reclassificar">
                                <i class="fas fa-exchange-alt pe-2"></i> Reclassificar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card_Tab>
</template>

<script>

import axios from 'axios';
    import Card_Tab from '@/components/Tickets/Ocorrencia/Card_Tab.vue'

export default {
    name: 'Ocorrencia Informacoes',
    props: {
        idOcorrencia: {
            type: Number,
            default: 0
        },
        refreshStatus: {
            type: Boolean,
            default: false
        },
        isFinalizado: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Card_Tab
    },
    data() {
        return {
            ocorrencia: {},
            dados: { cdInstituicao: 0, nmRazaoSocial: '', etapa_atual: '', nrDiasAbertura: 0 },
            cdSetorClassificacaoEtapa: 0,
            dinamicWid: ''
        }
    },
    computed: {
        returnClassEtapa() {
            let $this = this;

            switch ($this.cdSetorClassificacaoEtapa) {
                case 1:
                    return 'bg-color-1';
                case 2:
                    return 'bg-color-2';
                case 3:
                    return 'bg-color-3';
                case 4:
                    return 'bg-color-4';
                case 5:
                    return 'bg-color-5';
                case 6:
                    return 'bg-color-6';
                case 7:
                    return 'bg-color-7';
                case 8:
                    return 'bg-color-8';
                case 9:
                    return 'bg-color-9';
                case 10:
                    return 'bg-color-10';
                case 11:
                    return 'bg-color-11';
                case 12:
                    return 'bg-color-12';
                default:
                    return 'bg-color-default';
            }
        },
        returnTextEtapa() {
            let $this = this;

            switch ($this.cdSetorClassificacaoEtapa) {
                case 1:
                    return 'text-color-1';
                case 2:
                    return 'text-color-2';
                case 3:
                    return 'text-color-3';
                case 4:
                    return 'text-color-4';
                case 5:
                    return 'text-color-5';
                case 6:
                    return 'text-color-6';
                case 7:
                    return 'text-color-7';
                case 8:
                    return 'text-color-8';
                case 9:
                    return 'text-color-9';
                case 10:
                    return 'text-color-10';
                case 11:
                    return 'text-color-11';
                case 12:
                    return 'text-color-12';
                default:
                    return 'text-color-default';
            }
        },
    },
    methods: {
        updateSizeDinamic() {
            if (window.innerWidth <= 1400) {
                this.dinamicWid = 'padding-left: 14px !important;'
            } else if (window.innerWidth >= 3500) {
                this.dinamicWid = ''
            } else {
                this.dinamicWid = ''

            }
        },
        getOcorrencia() {
            let $this = this;

            axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                headers: $this.$api.getTokenComercial(),
                params: '',
                notLoading: true
            }).then(response => {
                $this.ocorrencia = response.data.data;
                $this.getCdSetorClassificacaoEtapa();

            })
        },
        getCdSetorClassificacaoEtapa() {
            let $this = this;

            axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacaoEtapa/GetCdSetorClassificacaoEtapa?idSetorClassificacaoEtapa=' + $this.ocorrencia.idSetorClassificacaoEtapaAtual, {
                headers: $this.$api.getTokenComercial(),
                params: '',
                notLoading: true
            }).then(response => {
                $this.cdSetorClassificacaoEtapa = response.data.data;
                $this.getDadosOcorrencia();
            })
        },
        getDadosOcorrencia() {
            let $this = this;

            axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetDadosOcorrencia?idOcorrencia=' + $this.idOcorrencia, {
                headers: $this.$api.getTokenComercial(),
                params: '',
                notLoading: true
            }).then(response => {
                $this.dados = response.data.data;
            })
        },
        setActionCard(action) {
            this.$emit('setActionCard', action);
        },
    },
    created() {
    },
    mounted() {
        this.getOcorrencia();

        this.updateSizeDinamic();
        window.addEventListener('resize', this.updateSizeDinamic);
    },
    updated() {
        this.updateSizeDinamic();
    },
    watch: {
        refreshStatus(newVal, oldVal) {
            this.getOcorrencia();
        },
        idOcorrencia(newVal, oldVal) {
            if (newVal == 0) {
                this.ocorrencia = {};
                this.dados = { cdInstituicao: 0, nmRazaoSocial: '', etapa_atual: '', nrDiasAbertura: 0 };
                this.cdSetorClassificacaoEtapa = 0;
            } else {
                this.getOcorrencia(newVal);
            }
        }
    }
}
</script>

<style scoped lang="scss">

    .cart-ticket-top {
        margin-bottom: 0;
        font-size: 12px;
        font-weight: bold;
    }

    .r-5 {
        margin-right: 5px;
    }

</style>